var _path, _path2, _path3, _circle, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddNewCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61012 0H32.7389C33.6245 0 34.349 0.765434 34.349 1.70096V20.4113C34.349 21.3468 33.6245 22.1122 32.7389 22.1122H1.61012C0.724559 22.1122 0 21.3468 0 20.4113V1.70089C0 0.765362 0.724559 0 1.61012 0Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63174 5.10278H14.9173C15.538 5.10278 16.0459 5.61305 16.0458 6.23675V7.93771C16.0458 8.56142 15.5379 9.07168 14.9172 9.07168H3.63174C3.01101 9.07168 2.50317 8.56142 2.50317 7.93771V6.23675C2.50317 5.61305 3.01101 5.10278 3.63174 5.10278ZM19.4315 5.10278H30.717C31.3377 5.10278 31.8456 5.61305 31.8455 6.23675V7.93771C31.8455 8.56142 31.3377 9.07168 30.717 9.07168H19.4315C18.8107 9.07168 18.3029 8.56142 18.3029 7.93771V6.23675C18.3029 5.61305 18.8107 5.10278 19.4315 5.10278Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3498 12.757H15.1996C15.6792 12.757 16.046 13.1539 16.046 13.6074C16.046 14.0893 15.6792 14.4578 15.1996 14.4578H3.3498C2.8702 14.4578 2.50342 14.0893 2.50342 13.6074C2.50342 13.1255 2.8702 12.757 3.3498 12.757ZM3.3498 15.5919H10.1211C10.6007 15.5919 10.9675 15.9888 10.9675 16.4423C10.9675 16.9242 10.6007 17.2928 10.1211 17.2928H3.3498C2.8702 17.2928 2.50342 16.9242 2.50342 16.4423C2.50342 15.9604 2.8702 15.5919 3.3498 15.5919Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 17.5,
    r: 6.5,
    fill: "#8FC21C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 14.25V21.25",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 17.75H33.25",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewCardIcon);
export default __webpack_public_path__ + "static/media/add_new_card_icon.acf3a0005856ae770adbc16ad2986ca1.svg";
export { ForwardRef as ReactComponent };